import api from './api';

const CURRENT_PROFILE_API_URL = '/api/users/me/profile';
const USER_PROFILE_API_URL = '/api/users';
const CURRENT_USER_API_URL = '/api/users/me';

export const getCurrentUserProfile = async () => {
  const response = await api.get(CURRENT_PROFILE_API_URL);
  return response.data;
};

export const getUserProfile = async (userId) => {
  const response = await api.get(`${USER_PROFILE_API_URL}/${userId}/profile`);
  return response.data;
};

export const updateCurrentUser = async (profile) => {
  const response = await api.put(CURRENT_USER_API_URL, profile);
  return response.data;
};
